import Message from '@sats-group/ui-lib/react/message';
import React from 'react';
import ContentContainer from '~/client/components/content-container/content-container';
import LinksBlock from '~/client/components/links-block/links-block';
import PreviewLayout from '~/client/components/preview-layout/preview-layout';
import type { LinksBlockPreview as Props } from './links-block-preview.types';

const LinksBlockPreview: React.FC<Props> = ({ linksBlock }) => (
  <PreviewLayout>
    <div className="links-block-preview">
      <ContentContainer>
        {linksBlock ? (
          <LinksBlock {...linksBlock} />
        ) : (
          <Message text="No links block props" />
        )}
      </ContentContainer>
    </div>
  </PreviewLayout>
);

export default LinksBlockPreview;
